import { isTWA } from '@/lib/twa';

/**
 * De onde o app está sendo usado (#375): o app da Play Store (TWA), o PWA
 * instalado na tela inicial ou o navegador. Vai para o GA4 (propriedade de
 * usuário) e para o RUM (atributo de sessão), e é o que permite medir o uso
 * pelo app no teste fechado da Play Store (#376).
 *
 * O GA4 recebe a plataforma pelo script inline do index.html, com a mesma
 * regra — mudar nos dois.
 */
export type Plataforma = 'twa' | 'pwa-instalado' | 'navegador';

export const detectarPlataforma = (): Plataforma => {
  if (typeof window === 'undefined') return 'navegador';
  // isTWA() já protege o sessionStorage (modo privado). Limite conhecido: com
  // ?web=true (link de suporte; anti-steering da Play Store) a detecção do TWA é desligada
  // de propósito, e um link desses aberto dentro do app conta como
  // 'pwa-instalado' — o TWA também roda em display-mode standalone.
  if (isTWA()) return 'twa';
  try {
    const standalone =
      window.matchMedia?.('(display-mode: standalone)')?.matches ||
      (window.navigator as Navigator & { standalone?: boolean }).standalone === true; // iOS
    if (standalone) return 'pwa-instalado';
  } catch {
    // matchMedia indisponível: trata como navegador.
  }
  return 'navegador';
};
